import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw933aApi, QueryRequest, QueryResponse } from '../../../services/pw933aApi';

export interface PW933AQueryState {
  loading: boolean;
  result: QueryResponse | null;
  queried: boolean;
  noData: boolean;
}

export interface PW933AQueryActions {
  runQuery: (req: QueryRequest) => Promise<void>;
  reset: () => void;
}

export function usePW933AQuery(): PW933AQueryState & PW933AQueryActions {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<QueryResponse | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (req: QueryRequest) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw933aApi.query(req);
      if (resp.data && resp.data.length > 0) {
        setResult(resp);
        setNoData(false);
      } else {
        setResult(null);
        setNoData(true);
        message.info('查無符合條件的薪資資料');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setResult(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, result, queried, noData, runQuery, reset };
}
